<template>
<div class="chapter">
<div class="inner_page">
<div class="body" style="white-space:pre-wrap">
<p class="s5">Copyright © 2008 by Adam-Troy Castro<br/>First published online at <span class="c1">Helix Speculative Fiction</span></p>
<p class="s2">Revised copyright © 2012 by Adam-Troy Castro<br/>All rights reserved.</p>
<p class="s2">Cover design by Eddie Schneider.</p>
<p class="s2">Published as an ebook by Jabberwocky Literary Agency, Inc.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?4fa6c54d